<div class="p-2 busy-overlay-parent" [ngClass]="isLoading ? 'disabled' : ''">
  <div *ngIf="isLoading" class="font-weight-bold busy-overlay">
    <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
  </div>

  <div
    *ngIf="errorMsg"
    class="alert alert-danger d-flex flex-row justify-content-between"
  >
    {{ errorMsg }}
    <div role="button" (click)="errorMsg = ''"><i class="fa fa-times"></i></div>
  </div>
  <table class="table table-striped table-sm" *ngIf="bTabSelected">
    <tr>
      <th colspan="2" class="text-center">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-center w-100">
            <h3 class="pt-1">Building {{ buildingId }}</h3>
          </div>
          <div class="d-flex pr-2 justify-content-end">
            <button
              class="btn btn-light text-nowrap text-info mx-2"
              (click)="showKmlViewer()"
              [disabled]="showingKmlViewer"
            >
              <i
                class="fa {{
                  showingKmlViewer ? 'fa-spinner fa-spin' : 'fa-globe'
                }} mr-1"
              ></i
              >KML
            </button>
            <button
              class="btn btn-light text-nowrap text-primary"
              (click)="loadBuilding()"
            >
              <i class="fa fa-redo mr-1"></i>Refresh
            </button>
          </div>
        </div>
      </th>
    </tr>
    <tr *ngFor="let field of $any(buildingFields || {}) | keyvalue">
      <th>{{ (field.key | underscore).split("_").join(" ") | ucwords }}</th>
      <ng-container [ngSwitch]="field.key">
        <td *ngSwitchCase="'updatedAt'">
          {{ building[$any(field).key] | date : "yyyy-MM-dd HH:mm:ss.SSS" }} ({{
            building[$any(field).key]
          }})
        </td>
        <td *ngSwitchDefault>
          {{ building[$any(field).key] }}
        </td>
      </ng-container>
    </tr>
  </table>
  <br />
  <div>
    <tabset class="p-0 m-0">
      <tab heading="Points">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Point ID</th>
              <th class="w-25">Floor</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody *ngIf="bTabSelected">
            <tr *ngFor="let buildingPoint of buildingPoints">
              <td>
                <a
                  href="javascript:false;"
                  (click)="showPoint(buildingPoint)"
                  >{{ buildingPoint._id }}</a
                >
              </td>
              <td>{{ buildingPoint.floorAndDescript }}</td>
              <td>{{ buildingPoint.locationDescription }}</td>
            </tr>
          </tbody>
        </table>
      </tab>
      <tab heading="Weather">
        <div class="p-2 border-left border-right border-bottom">
          <app-weather-query
            *ngIf="!isResettingWeather && building"
            [latitude]="building?.civicLatitude"
            [longitude]="building?.civicLongitude"
            ><button class="btn btn-warning" (click)="resetWeather()">
              Reset
            </button>
          </app-weather-query>
        </div>
      </tab>
    </tabset>
  </div>
  <div class="mt-2">
    <button
      class="btn btn-light text-nowrap text-primary"
      (click)="loadBuilding()"
    >
      <i class="fa fa-redo mr-2"></i>Refresh
    </button>
  </div>
</div>
